(function () {

    window.oneadvanced = window.oneadvanced || {};
    window.oneadvanced.breadcrumbschema = window.oneadvanced.breadcrumbschema || {};
    window.oneadvanced.breadcrumbschema.init = function () {
        //console.log("initialising breadcrumbschema...");
        //Generate breadcrumb schema dynamically by fetching list element within breadcrumb css class
        var $breadcrumbContent = $('.breadcrumb li');
        if ($breadcrumbContent.length) {
            var breadcrumbScript = document.createElement('script');
            breadcrumbScript.type = 'application/ld+json';
            var breadcrumbList = {
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": []
            };

            var count = 0;
            do {
                var item = {};
                var href = $breadcrumbContent.eq(count).find("a").attr('href');
                item["@id"] = href ? location.protocol + "//" + location.host + href : location.href;
                item["name"] = $.trim($breadcrumbContent.eq(count).text().replace(/Current:/g, ''));

                breadcrumbList.itemListElement.push({
                    "@type": "ListItem",
                    "position": count + 1,
                    item
                });
                count++;
            } while (count < $breadcrumbContent.length);

            breadcrumbScript.innerHTML = JSON.stringify(breadcrumbList);
            //console.log(breadcrumbList);
            document.getElementsByTagName('head')[0].appendChild(breadcrumbScript);
        }
    };
    window.oneadvanced.breadcrumbschema.hasLoaded = true;

})();